import { ReactNode } from "react";

const EmptyText = ({
  trigger,
  children,
}: {
  trigger: string | number | null | "";
  children: ReactNode;
}) => {
  return (
    <>
      {trigger ? (
        children
      ) : (
        <div className="text-tiny-normal italic font-medium text-neutral-500">
          is empty
        </div>
      )}
    </>
  );
};

export default EmptyText;
